export const GateEndpoints = {
  SCAN: '/api/admin/logistics/cnc/gate/scan',
  ADMIT: '/api/admin/logistics/cnc/gate/admit',
};
